import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/tooltip.svg'


const _withScopeId = n => (_pushScopeId("data-v-420567ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-info-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_3 = {
  key: 1,
  class: "btns-wrapper"
}
const _hoisted_4 = { class: "btn-book-wrapper" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper" }, [
  /*#__PURE__*/_createElementVNode("p", null, "자주 사용하는 노선이라면"),
  /*#__PURE__*/_createElementVNode("p", null, "즐겨찾기 등록을 해보세요!")
], -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("footer", null, [
      _hoisted_2,
      (!$setup.isBookable)
        ? (_openBlock(), _createBlock($setup["ToggleButton"], {
            key: 0,
            title: $setup.favoriteBtnTitle,
            isOn: !$props.isFavorite,
            onOnClickToggleButton: $setup.onClickFavorite
          }, null, 8 /* PROPS */, ["title", "isOn"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn-favorite", { 'no-book': !$setup.isBookable, favorite: $props.isFavorite }]),
              onClick: $setup.onClickFavorite
            }, [
              _createVNode($setup["InlineSvg"], {
                src: $setup.favoriteImage,
                alt: "즐겨찾기",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"])
            ], 2 /* CLASS */),
            _createElementVNode("div", _hoisted_4, [
              ($props.isDailyBookAvailable && $props.isMonthlyBookAvailable)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("button", {
                      class: "btn-daily-book",
                      disabled: $setup.isBookBlocked || $setup.isBookCountExceeded,
                      onClick: $setup.onClickDailyBook
                    }, " 일예약 ", 8 /* PROPS */, _hoisted_5),
                    _createElementVNode("button", {
                      class: "btn-monthly-book",
                      disabled: $setup.isBookBlocked || $setup.isBookCountExceeded,
                      onClick: $setup.onClickMonthlyBook
                    }, " 월예약 ", 8 /* PROPS */, _hoisted_6)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn-daily-book only-daily-book",
                    disabled: $setup.isBookBlocked || $setup.isBookCountExceeded,
                    onClick: $setup.onClickBook
                  }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(`${$props.isMonthlyBookAvailable ? "월 예약하기" : "예약하기"}`), 1 /* TEXT */),
                      ($props.isLoggedIn && $setup.shouldShowUserRemainBookCount)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (잔여횟수: " + _toDisplayString($setup.userRemainBookCount) + "회) ", 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 8 /* PROPS */, _hoisted_7))
            ])
          ]))
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($setup.shouldShowTips)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "tips-favorite-wrapper",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.hideTips(0)))
            }, [..._hoisted_10]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}